<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-card class="w-100 rounded-lg">
      <v-card-title>{{ $t('tslContractors.filter') }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="5">
            <CountryFlagSelect
              v-model="localFilters.countries"
              class="mb-2"
              multiple
              hide-details
              :label="$t('tslContractors.country')"
            />
          </v-col>
        </v-row>

        <v-text-field
          v-model="localFilters.city"
          :label="$t('tslContractors.city')"
          dense
          outlined
          hide-details
          class="mb-2"
        >
        </v-text-field>

        <v-select
          v-model="localFilters.cooperationStatus"
          :items="cooperationStatuses"
          :label="$t('tslContractors.cooperationStatus')"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details
          class="mb-2"
        >
        </v-select>
      <v-card-actions class="d-flex px-0">
        <v-btn outlined @click="close()">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn color="primary" @click="filter()" class="ml-auto" depressed>
          {{ $t('tslContractors.filter') }}
        </v-btn>
      </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import CountryFlagSelect from '@/components/CountryFlagSelect'

export default {
  name: 'TSLFilterDialog',
  components: {
    CountryFlagSelect
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      cooperationStatuses: [
        { text: this.$t('tslContractors.active'), value: 1 },
        { text: this.$t('tslContractors.suspended'), value: 2 }
      ]
    }
  },
  computed: {
    localFilters: {
      get () {
        return this.filters
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    filter () {
      this.$emit('filter', this.filters)
    }
  }
}
</script>
